import { render } from "./MFileUploader.vue?vue&type=template&id=5768046a&scoped=true"
import script from "./MFileUploader.vue?vue&type=script&lang=js"
export * from "./MFileUploader.vue?vue&type=script&lang=js"

import "./MFileUploader.vue?vue&type=style&index=0&id=5768046a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5768046a"]])

export default __exports__